import { Component, type ErrorInfo, type ReactNode } from "react";
import { Link } from "react-router-dom";
import styles from "./SectionErrorBoundary.module.scss";

type Props = {
  sectionName: string;
  detailPath?: string;
  children: ReactNode;
};

type State = {
  hasError: boolean;
};

export class SectionErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  override componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error(`[PageView] ${this.props.sectionName} render error:`, error, errorInfo);
  }

  override render() {
    if (this.state.hasError) {
      return (
        <div className={styles["fallback"]}>
          <p className={styles["fallbackText"]}>
            {this.props.sectionName}のコンテンツを表示できません。
          </p>
          {this.props.detailPath && (
            <Link to={this.props.detailPath} className={styles["fallbackLink"]}>
              詳細ページで確認 →
            </Link>
          )}
        </div>
      );
    }

    return this.props.children;
  }
}
